import { styled } from '@mui/material';
import { Companies } from '../../models/domain/enum';
import { getCompany } from '../../utils/company';

const getBreadcrumbNavContainerStyles = (company: Companies, theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        padding: `${theme.spacings.unit(2)} 
          ${theme.spacings.unit(10)} 
          ${theme.spacings.unit(2)} 
          ${theme.spacings.unit(10)}`,
        [theme.breakpointsMediaQuery.up('md')]: {
          padding: `${theme.spacings.unit(2)} 
            ${theme.spacings.unit(26)} 
            ${theme.spacings.unit(2)} 
            ${theme.spacings.unit(26)}`,
        },
        [theme.breakpointsMediaQuery.up('xl')]: {
          maxWidth: theme.spacings.unit(1960 / 4),
          margin: '0 auto',
          padding: `${theme.spacings.unit(2)} 
            ${theme.spacings.unit(20 / 4)} 
            ${theme.spacings.unit(2)} 
            ${theme.spacings.unit(20 / 4)}`,
        },
      };
    case Companies.FELSINEA:
      return {
        padding: `${theme.spacings.unit(6)} 
          ${theme.spacings.unit(10)} 
          ${theme.spacings.unit(6)} 
          ${theme.spacings.unit(10)}`,
        [theme.breakpointsMediaQuery.up('md')]: {
          padding: `${theme.spacings.unit(6)} 
            ${theme.spacings.unit(26)} 
            ${theme.spacings.unit(6)} 
            ${theme.spacings.unit(26)}`,
        },
        [theme.breakpointsMediaQuery.up('xl')]: {
          maxWidth: theme.spacings.unit(1960 / 4),
          margin: '0 auto',
          padding: `${theme.spacings.unit(6)} 
            ${theme.spacings.unit(20 / 4)} 
            ${theme.spacings.unit(6)} 
            ${theme.spacings.unit(20 / 4)}`,
        },
      };
  }
};

const getBreadCrumbWrapperStyles = (company: Companies, theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        backgroundColor: theme.colors.secondaryBackground,
      };
    case Companies.FELSINEA:
      return {};
  }
};

export const BreadcrumbWrapperStyled = styled('section', {
  shouldForwardProp: (prop) => ![''].includes(prop as string),
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  ...getBreadCrumbWrapperStyles(getCompany(), theme),
}));

export const BreadcrumbNavContainerStyled = styled('div', {
  shouldForwardProp: (prop) => ![''].includes(prop as string),
})(({ theme }) => ({
  maxWidth: theme.spacings.unit(1960 / 4),
  width: '100%',
  ...getBreadcrumbNavContainerStyles(getCompany(), theme),
}));
